import { render } from "./LayoutWithNavigation.vue?vue&type=template&id=1f684b24&scoped=true"
import script from "./LayoutWithNavigation.vue?vue&type=script&lang=js"
export * from "./LayoutWithNavigation.vue?vue&type=script&lang=js"

import "./LayoutWithNavigation.vue?vue&type=style&index=0&id=1f684b24&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f684b24"]])

export default __exports__